const divSignUpTenantsCards = {
  header: 'Selecione a sua empresa: *',
  headerError: 'Selecione uma empresa'
};

export default divSignUpTenantsCards;
